export default __webpack_public_path__ + "static/media/solar-logo.cc0ccb33.png";